// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

const S = {
  Avatar: styled.img`
    margin-right: 0px;
    border-radius: 50%;
    width: 60px;
    height: 60px;
  `,
  Title: styled.div`
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    color: #FFFFFF;
    text-transform: uppercase;
  `,
  AvatarWrapper: styled.div`
    margin-right: 0px;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FCA032;
  `,
  MessageWrapper: styled.div`
    width: 100%;
    display: inline-flex;
    margin-bottom: 31px;
  `,
  Message: styled.div`
    width: 445px;
    margin-left: auto;
    margin-right: 16px;
    display: flex;
    flex-direction: column;
    padding: 14px 20px 21px 20px;
    background: rgba(239, 239, 239, 0.5);
    border-radius: 4px;
  `,
  Name: styled.div`
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    color: #434343;
    margin-bottom: 7px;
  `,
  MessageText: styled.div`
    font-weight: 400;
    font-size: 16px;
    line-height: 23px;
    color: #434343;
    word-break: break-all;
  `,
  Time: styled.div`
    font-size: 14px;
    line-height: 20px;
    color: #848484;
    margin-top: 16px;
  `,
  MessageImages: styled.div`
    display: inline-grid;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: 137px;
    grid-gap: 13px;
    margin-top: 14px;
  `,
  Image: styled.img`
    width: 100%;
    height: 100%;
    cursor: zoom-in;
    object-fit: cover;
  `,
};

export { S as default };

